// extracted by mini-css-extract-plugin
module.exports = {"title":"ToastBody_title__aVGSX","message":"ToastBody_message__yBaDl","useFade-fadeIn":"ToastBody_useFade-fadeIn__6Ypi5","useFade-fadeOut":"ToastBody_useFade-fadeOut__maTeX"};